import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserService } from '../Services/user';
import { AuthService } from '../Services/auth';
import { Address } from '../Models/address';
import { User } from '../Models/user';


@Component({
  selector: 'app-address',
  templateUrl: '../Templates/addressform.html',
})


export class AddressComponent implements OnInit {

  model: Address;
  user: User;
  postalToShipping: boolean = true;

  constructor(private userService: UserService,
              private auth: AuthService) {}

  @ViewChild('addressForm') form;
  @Output() submitted: EventEmitter<Address> = new EventEmitter();
  @Input() embed: boolean;

  ngOnInit() {

    this.model = new Address();

    this.auth.getUser().subscribe(
      user => {
        this.user = user;

        if ((!this.user) || this.user.is_tmp) {
          return;
        }

        if (this.user._links.address) {
          this.userService.getAddress(this.user).subscribe(
            data => { this.model = data }
          );
        }
      }
    );
  }

  isValid(): boolean {
    return this.form && this.form.valid;
  }

  submit() {
    this.submitted.next(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/address.ts